exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".geo-suggestion[data-v-be384664]{display:flex;align-items:center;gap:8px;background:#eff6ff;border:1px solid #bfdbfe;border-radius:8px;padding:8px 12px;font-size:13px;color:#1d4ed8;margin-bottom:8px}.geo-suggestion span[data-v-be384664]{flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.geo-suggestion button[data-v-be384664]{background:none;border:none;color:inherit;cursor:pointer;padding:0;font-size:13px;flex-shrink:0}.geo-suggestion button[data-v-be384664]:first-of-type{font-weight:600;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-be384664","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/detenteur/NewDetenteur.vue
// module id = 659
// module chunks = 0